import { useEffect, useState } from "react";

// Refresh on returning to a tab or reconnecting; no page reload or reading jump.
export const useNewsRefresh = () => {
  const [revision, setRevision] = useState(0);
  useEffect(() => {
    let last = 0;
    const refresh = () => {
      if (document.visibilityState !== "hidden" && Date.now() - last > 1000) {
        last = Date.now();
        setRevision((value) => value + 1);
      }
    };
    window.addEventListener("focus", refresh);
    window.addEventListener("online", refresh);
    document.addEventListener("visibilitychange", refresh);
    return () => {
      window.removeEventListener("focus", refresh);
      window.removeEventListener("online", refresh);
      document.removeEventListener("visibilitychange", refresh);
    };
  }, []);
  return revision;
};